import globals from '../globals';
import { UserAuthMethodClass } from '../../components/descope-user-auth-method/UserAuthMethodClass';
import { getThemeRefs } from '../../helpers/themeHelpers';

const globalRefs = getThemeRefs(globals);
export const vars = UserAuthMethodClass.cssVarList;

const userAuthMethod = {
  [vars.hostDirection]: globalRefs.direction,
  [vars.itemsGap]: '16px',
  [vars.hostMinWidth]: '310px',
  [vars.hostWidth]: '530px',
  [vars.hostMaxWidth]: '100%',
  [vars.iconSize]: '24px',
  [vars.iconColor]: 'currentcolor',
  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default userAuthMethod;
